import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid } from "antd";
import { App } from "antd";
import InputField from "../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOriginsList, createOrUpdateOrigin } from "../originsThunks";
import { setSelectedOrigin, setIsEditOrigin } from "../originsSlice";
import { getAccessType } from "../../../lib/functions";

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateOriginsForm = () => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();
  const screens = useBreakpoint();

  const { isEditOrigin, selectedOrigin } = useSelector((state) => state.origins);
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("origin_manage");
    access_type_set(access);
  }, []);

  useEffect(() => {
    if (isEditOrigin && selectedOrigin) {
      form.setFieldsValue(selectedOrigin);
    } else {
      form.resetFields();
    }
  }, [isEditOrigin, selectedOrigin]);

  const handleCancel = () => {
    dispatch(setSelectedOrigin(null));
    dispatch(setIsEditOrigin(false));
    navigate(-1);
  };

  const handleSave = async (values) => {
    try {
      await dispatch(
        createOrUpdateOrigin({
          ...values,
          action: isEditOrigin ? "update" : "create",
          origin_id: selectedOrigin?.origin_id || 0,
        })
      ).unwrap();

      modal.success({
        title: isEditOrigin ? "Origin updated successfully" : "Origin created successfully",
      });

      dispatch(setSelectedOrigin(null));
      dispatch(setIsEditOrigin(false));
      navigate("/inventory/origins-manage");
    } catch (err) {
      modal.error({ title: err.message || "Save failed" });
    }
  };

  return (
    <div className="origin-form">
      <Title level={2} style={{ marginBottom: "32px" }}>
        {isEditOrigin ? "Update Origin" : "Create New Origin"}
      </Title>
      <Form
        form={form}
        layout="horizontal"
        onFinish={handleSave}
        variant="filled"
        style={{ maxWidth: "1400px" }}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 18 }}
      >
        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: !screens.md || !screens.xl ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          <Flex vertical gap={10} style={{ width: !screens.md || !screens.xl ? "100%" : "40%" }}>
            <Form.Item label="Origin Name" name="origin_name" rules={[{ required: true }]}>
              <InputField placeholder="Enter Origin Name" />
            </Form.Item>
          </Flex>
        </Flex>

        <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
          <Button size="large" onClick={handleCancel} className="traic-button">
            Back
          </Button>
          {access_type == "WRITE" && <>
            <Button type="primary" size="large" htmlType="submit" className="traic-button">
              {isEditOrigin ? "Update" : "Save"}
            </Button>
          </>}
        </Flex>
      </Form>
    </div>
  );
};

export default CreateOriginsForm;
